export default __webpack_public_path__ + "assets/images/45710d4a6bb374a75b8a2c746fe315c4.mp3";